import { ComponentProps, ReactNode } from 'react';
import { GroupBase, OnChangeValue } from 'react-select';
import { useField } from 'formik';

import FormGroup from './FormGroup';
import Select from './Select';

function FormSearchSelectInput<
  Option = unknown,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  label,
  labelFor,
  tooltip,
  ...props
}: {
  label?: ReactNode;
  labelFor?: string;
  name: string;
  tooltip?: string;
} & ComponentProps<typeof Select<Option, IsMulti, Group>>): JSX.Element {
  const [field, meta, helpers] = useField<OnChangeValue<Option, IsMulti>>(
    props.name,
  );
  const hasError = !!(meta.touched && meta.error);

  return (
    <FormGroup
      error={hasError ? meta.error : ''}
      label={label}
      labelFor={labelFor}
      tooltip={tooltip}
    >
      <Select
        {...field}
        {...props}
        hasError={hasError}
        onBlur={(event) => {
          helpers.setTouched(true);
          props.onBlur?.(event);
        }}
        onChange={(value, actionMeta) => {
          helpers.setValue(value);
          props.onChange?.(value, actionMeta);
        }}
      />
    </FormGroup>
  );
}

export default FormSearchSelectInput;
